import $ from 'jquery';

window.zESettings = {
    webWidget: {
        color: {
            theme: '#635bff'
        },
        position: {horizontal: 'right', vertical: 'bottom'},
        zIndex: 9999999999,
        launcher: {
            label: {
                'en-US': 'Contact Us'
            }
        },
        contactForm: {
            title: {
                'en-US': 'Contact Payment Plugins',
            },
            fields: [
                {id: '360024242873', prefill: {'*': 'Stripe'}}
                /*{id: '4423709831443', prefill: {'*': JSON.stringify(wcStripeSupportParams.report, null, 2)}}*/
            ]
        },
        helpCenter: {
            suppress: true
        }
    }
}

window.zEmbed || function (e, t) {
    var n, o, d, i, s, a = [], r = document.createElement("iframe");
    window.zEmbed = function () {
        a.push(arguments)
    }, window.zE = window.zE || window.zEmbed, r.src = "javascript:false", r.title = "", r.role = "presentation", (r.frameElement || r).style.cssText = "display: none", d = document.getElementsByTagName("script"), d = d[d.length - 1], d.parentNode.insertBefore(r, d), i = r.contentWindow, s = i.document;
    try {
        o = s
    } catch (e) {
        n = document.domain, r.src = 'javascript:var d=document.open();d.domain="' + n + '";void(0);', o = s
    }
    o.open()._l = function () {
        var o = this.createElement("script");
        n && (this.domain = n), o.id = "js-iframe-async", o.src = e, this.t = +new Date, this.zendeskHost = t, this.zEQueue = a, this.body.appendChild(o)
    }, o.write('<body onload="document._l();">'), o.close()
}("https://assets.zendesk.com/embeddable_framework/main.js", "paymentplugins.zendesk.com");

$(() => {
    if (typeof wc_stripe_setting_params === 'undefined') {
        return;
    }
    zE(function () {
        zE.hide();
        $(document.body).append(wc_stripe_setting_params.help_widget);
        const $widget = $('#pp-help-widget');
        const $toggle = $('#pp-help-toggle');
        const $dropdown = $('#pp-help-dropdown');

        $toggle.on('click', function (e) {
            e.stopPropagation();
            var isOpen = $dropdown.is(':visible');
            if (isOpen) {
                closeDropdown();
            } else {
                openDropdown();
            }
        });

        $('#pp-help-contact').on('click', function () {
            closeDropdown();
            zE.activate();
        });

        $(document).on('click', function (e) {
            if (!$(e.target).closest('#pp-help-widget').length) {
                closeDropdown();
            }
        });

        $(document).on('keydown', function (e) {
            if (e.key === 'Escape') {
                closeDropdown();
            }
        });

        function openDropdown() {
            $dropdown.stop(true, true).slideDown(150);
            $toggle.addClass('pp-help-open');
        }

        function closeDropdown() {
            $dropdown.stop(true, true).slideUp(150);
            $toggle.removeClass('pp-help-open');
        }
    });
    zE('webWidget', 'prefill', {
        name: {
            value: wc_stripe_setting_params.name
        },
        email: {
            value: wc_stripe_setting_params.email
        }
    });
});